<template>
  <div class="basket">
    <div
      class="order-header my-3 text-center text-uppercase font-weight-bold d-flex justify-content-center align-items-center"
    >
      <span class="mr-2">Twoje zamówienie</span>
      <OrderIcon />
    </div>
    <div v-for="b in basket.basket.baskets" class="order-header-basket order-group">
      <div class="order-header-address">
        <span>Adres dostawy:</span>
        <span
          v-if="b.address"
          class="order-group-delivery"
        >{{ b.address.city }}, {{ b.address.street }}</span>
      </div>

      <div class="table-responsive">
        <table class="table order-header-cols">
          <thead>
            <tr>
              <th scope="col">zdjęcie</th>
              <th scope="col">nazwa</th>
              <th scope="col">ilość</th>
              <th scope="col">netto</th>
              <th scope="col">vat</th>
              <th scope="col">brutto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="position in b.positions" class="order-position">
              <td>
                <img
                  :src="[position.photo_url === '/nophoto.png' ? '//cdn01.redbay.pl/layouts/boma/img/noimg.jpg' : position.photo_url]"
                  class="img-fluid"
                />
              </td>
              <td class="order-name">
                <span class="order-label">nazwa</span>
                <span class="order-name-name">{{position.name}}</span>
                <span class="order-name-desc">{{position.description}}</span>
              </td>
              <td>
                <span class="order-label">ilość</span>
                <span>{{position.cart_quantity}}</span>
              </td>
              <td class="order-price">
                <span class="order-label">netto</span>
                <span>{{formatPrice(position.price_net * position.cart_quantity)}} {{currency().currency.symbol}}</span>
              </td>
              <td class="order-price">
                <span class="order-label">vat</span>
                <span>{{formatPrice(position.price_tax * position.cart_quantity)}} {{currency().currency.symbol}}</span>
              </td>
              <td class="order-price">
                <span class="order-label">brutto</span>
                <span>{{formatPrice(position.price_gross * position.cart_quantity)}} {{currency().currency.symbol}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="basket-footer">
          <td></td>
          <td></td>
          <td>Razem:</td>
          <td>
            <span class="order-footer-mobile-label">netto</span>
            <span>{{formatPrice(b.price_net)}} {{currency().currency.symbol}}</span>
          </td>
          <td>
            <span class="order-footer-mobile-label">vat</span>
            <span>{{formatPrice(b.price_tax)}} {{currency().currency.symbol}}</span>
          </td>
          <td>
            <span class="order-footer-mobile-label">brutto</span>
            <span>{{formatPrice(b.price_gross)}} {{currency().currency.symbol}}</span>
          </td>
        </div>
      </div>
    </div>

    <div class="order-header my-4 d-flex justify-content-end">
      <button type="button" class="btn btn-dark" @click="createOrder()">Złóż zamówienie</button>
    </div>
  </div>
</template>


<script>
import DeleteIcon from "vue-material-design-icons/delete.vue";
import SubIcon from "vue-material-design-icons/minus.vue";
import PlusIcon from "vue-material-design-icons/plus.vue";
import { mapState, mapGetters } from "vuex";
import MinusIcon from "vue-material-design-icons/minus.vue";
import OrderIcon from "vue-material-design-icons/BriefcaseCheck.vue";

export default {
  components: {
    OrderIcon
  },
  computed: {
    ...mapState({
      basket: state => state.basket,
      order: state => state.order
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },

  methods: {
    formatPrice(value) {
      let currValue = value * this.currency().value;

      let val = (currValue / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    async createOrder() {
      await this.$store.dispatch("order/create");
      this.$router.replace({ name: "orders" });
    }
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }

    this.$store.dispatch("basket/data");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/order/src/CreateOrderPage.vue